import {
  Box_default
} from "./chunk-GDQZHQO7.js";

// packages/ui-lib/src/layout/ContentBlock.tsx
import React2 from "react";

// packages/ui-lib/src/layout/ContentBlock.css.ts
var maxWidth = { xsmall: "ContentBlock_xsmall__4cf6s50", small: "ContentBlock_small__4cf6s51", medium: "ContentBlock_medium__4cf6s52", large: "ContentBlock_large__4cf6s53" };

// packages/ui-lib/src/layout/ContentBlock.tsx
var ContentBlock = ({
  children,
  width = "medium"
}) => /* @__PURE__ */ React2.createElement(Box_default, {
  boxWidth: "full",
  className: maxWidth[width]
}, children);

export {
  ContentBlock
};
//# sourceMappingURL=chunk-46SOUSGS.js.map
